import React, { useEffect, useState } from "react";
import { DatatablesFooterServerSide, Loading, Modal } from "App/Component/ui";

import { Paper } from "@material-ui/core";
import { useDatatablesServerSide } from "App/hooks";
import { defaultToastError } from "App/utils/helpers";
import { STYLE_DEFAULT_MASTER } from "App/constants";

import { TableDaftarRequest } from "../../../DaftarHelpDesk/DaftarHelpDesk";
import Title from "App/Component/ui/title/Title";
import {
  getByFilter,
  RESET_STATE_FORM_FILTER,
} from "../../../DaftarHelpDesk/helpers";
import FormFilter from "../../../DaftarHelpDesk/FormFilter";

function ModalListHD({
  setShowModal,
  handleClickSelect,
  rowsSelect,
  setRowsSelect,
}) {
  const classes = STYLE_DEFAULT_MASTER();

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilter(formFilter, pages, limit, true);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  return (
    <>
      <Modal title="Pilih Help Desk" show={setShowModal} width="90%">
        <div className={classes.root}>
          <Title title={"Daftar Request Help Desk"} />

          <Paper
            className={classes.paper}
            style={{
              padding: "1rem",
            }}
          >
            <FormFilter
              formFilter={formFilter}
              setFormFilter={setFormFilter}
              setNewData={setNewData}
            />
            <Loading show={loading} />
            <TableDaftarRequest
              rowsSelect={rowsSelect}
              setRowsSelect={setRowsSelect}
              rows={rows}
              classes={classes}
              onlySelect={true}
              setShowModal={setShowModal}
              handleClickSelect={handleClickSelect}
            />
            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </Paper>
        </div>
      </Modal>
    </>
  );
}

export default ModalListHD;
